import React from 'react';

import { Button, Flexbox, GreyBox, media, StyledLink } from '@morressier/ts';

import CopyToClipboard from 'react-copy-to-clipboard';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { logEvent } from 'utils/eventTracking';

// eslint-disable-next-line react/require-default-props
type Props = { doi?: string };

const Inner = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  gap: 1rem;

  ${media.medium`
    align-items: center;
    flex-direction: row;
  `}

  a {
    word-wrap: break-word;
    max-width: 100%;
  }
`;

const DOISection = ({ doi }: Props) => (
  <GreyBox padding="1rem 1rem 1rem 2rem" style={{ overflowX: 'auto' }}>
    <Inner>
      <StyledLink
        size="body1_new"
        color="primaryLink"
        style={{ whiteSpace: 'normal' }}
        // @ts-ignore
        target="_blank"
        // @ts-ignore wrong type in @morressier/ts
        href={`https://doi.org/${doi}`}
      >
        https://doi.org/
        {doi}
      </StyledLink>

      <div style={{ flexShrink: 1 }}>
        <CopyToClipboard text={`https://doi.org/${doi}`}>
          <Button
            onClick={() => {
              toast('DOI copied to clipboard');
              logEvent('DOI_LINK_CLICKED');
            }}
            iconLeft={<FaCopy />}
          >
            Copy DOI
          </Button>
        </CopyToClipboard>
      </div>
    </Inner>
  </GreyBox>
);

export default DOISection;
